import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  Label, Input, FormGroup, Row, Col, Button, Progress, Alert,Table, Card, CardBody
} from 'reactstrap';
import Switch from 'react-switch';

import AppList from '../../../../../assets/data/audience/apps.json';
import LocationPicker from '../../../audience/AudienceCreate/LocationPicker';
import { createTargetManualy } from '../../../../../slices/veloxity/targetAudience/createTargetManualy';
import { showErrorAlert, showSuccessAlert } from  '../../../../../components/custom/sweetalertHelper';
import { getAllTargetAudience } from '../../../../../slices/veloxity/targetAudience/getAllTargetAudience';
import { getProducts } from '../../../../../slices/veloxity/audience/GetProductsReducer';

import { Plus, X } from 'react-feather';

const CreateTargetManuallyForm = ({ 
  createAudienceName, setCreateAudienceName, 
  profileTypeOptions, selectedPersonaType, setSelectedPersonaType, 
  startDate, setStartDate, endDate, setEndDate, 
  existingNames, setPopup, toggle, onSuccess, onError
}) => {
  const [generations, setGenerations] = useState([]);
  const [genders, setGenders] = useState([]);
  const [inApps, setInApps] = useState([]);
  const [notInApps, setNotInApps] = useState([]);
  const [locations, setLocations] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [step, setStep] = useState(1);
  const [osType, setOsType] = useState('ANDROID');
  const [userStatus, setUserStatus] = useState('ACTIVE');
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [andOrCondition, setAndOrCondition] = useState(true); 
  const subscriptions = useSelector(state => state.getPermissionsList.subscriptions); 

  const [products, setProducts] = useState([
    { name: '', minUsage: 0, productType: 'Purchase', forAnalytics: true, forPrediction: false }
  ]);

  const hasFeature = (feature) => {
    const audienceSubscription = subscriptions?.find(sub => sub.subscriptionType === "TARGET_AUDIENCE");
    return audienceSubscription?.featureFlags?.[feature] === true;  
  };

  const handleConditionToggle = () => {
    setAndOrCondition(!andOrCondition);
  };

  const oneYearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
  const today = new Date().toISOString().split('T')[0];

  const filteredProfileTypeOptions = osType === 'MIXED' ? 
    [...profileTypeOptions.ios, ...profileTypeOptions.android] : 
    profileTypeOptions[osType.toLowerCase()];


  const generationOptions = [
    { value: 'ALPHA', label: 'ALPHA' },
    { value: 'BABY_BOOMER', label: 'BABY BOOMER' },
    { value: 'X', label: 'Generation X' },
    { value: 'Y', label: 'Generation Y' },
    { value: 'Z', label: 'Generation Z' },
  ];

  const genderOptions = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
  ];

  const appOptions = AppList.map(app => ({ value: app.bundleId, label: app.packageInfo }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const dispatch = useDispatch();

  const productsList = useSelector(state => state.getProducts.payload?.products || []);

  const productOptions = productsList.map(product => ({
    value: product,
    label: product
  }));

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await dispatch(getProducts()).unwrap();
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, [dispatch]);


  const checkNameExists = (name) => {
    const normalizedExistingNames = existingNames.map(name => name.toLowerCase());
    if (normalizedExistingNames.includes(name.toLowerCase())) {
      setPopup('nameError');
      setTimeout(() => setPopup(null), 3000);
      return true;
    }
    return false;
  };

  const formatDateTime = (date, time) => {
    const [hours, minutes, seconds] = time.split(':');
    date.setHours(hours, minutes, seconds, 0);
    return date.toISOString().slice(0, 19);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowError(false);
    setLoading(true);

    if (setLoading) setLoading(true);
  
    const nameInput = createAudienceName.trim();
  
    if (checkNameExists(nameInput)) {
      setLoading(false);
      return;
    }
  
    const personas = selectedPersonaType ? selectedPersonaType.map(pt => pt.value) : [];
  
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
  
    const startDateTime = formatDateTime(startDateObj, '08:00:00');
    const endDateTime = formatDateTime(endDateObj, '20:00:00');
  
    const inAppValues = inApps.map(app => app.value);
    const notInAppValues = notInApps.map(app => app.value);
    const overlappingApps = inAppValues.filter(value => notInAppValues.includes(value));
    const operationType = andOrCondition ? "AND" : "OR";;

  
    const filteredProducts = products.slice(1).filter(product => product.name);

    if (overlappingApps.length > 0) {
      setShowError(true);
      setLoading(false);
      return;
    }
  
    const selectionConfig = {
      osType: hasFeature("manuel::os_type") ? osType : null,
      timeRange: hasFeature("manuel::time_range") && (startDateTime || endDateTime) ? {
        startDate: startDateTime || null,
        endDate: endDateTime || null,
      } : null,
      profile: selectedPersonaType?.length > 0 ? {
        operationType,
        personas: selectedPersonaType.map(pt => pt.value)
      } : null,
      userStatus: hasFeature("manuel::user_status") ? userStatus : null,
      product : (hasFeature("manuel::product_analytic") || hasFeature("manuel::product_prediction")) && filteredProducts.length > 0 ? filteredProducts : null,
      generations: hasFeature("manuel::generation") && generations.length > 0 ? generations.map(gen => gen.value) : null,
      genders: hasFeature("manuel::gender") && genders.length > 0 ? genders.map(gen => gen.value) : null,
      app: hasFeature("manuel::app") && (inAppValues.length > 0 || notInAppValues.length > 0) ? {
        inApps: inAppValues,
        notInApps: notInAppValues,
      } : null,
      locations: hasFeature("manuel::location") && locations.length > 0 ? locations.map(loc => ({
        lat: loc.lat,
        lon: loc.lon,
        meter: loc.meter,
      })) : null
    };
  
    try {
      const response = await dispatch(createTargetManualy({
        name: nameInput,
        selectionConfig
      }));
    
      if (response.meta.requestStatus === 'fulfilled') {
        showSuccessAlert("Success", "Audience created successfully");
        dispatch(getAllTargetAudience());
      } else {
        showErrorAlert("Error", "Failed to create audience.");
      }
    } catch (error) {
      showErrorAlert('Error', error);
    } finally {
      toggle();
      setLoading(false);
    }
    
  };
  
  

  useEffect(() => {
    setSelectedPersonaType([]);
  }, [osType]);

  const hasStep2Features = () => {
    return hasFeature("manuel::generation") || 
           hasFeature("manuel::gender") || 
           hasFeature("manuel::app") || 
           hasFeature("manuel::location");
  };


  const renderStep1 = () => (
    <>
      <Progress 
          value={1} 
          max={(hasStep2Features() && hasProductFeatures()) 
            ? 3 
            : (hasStep2Features() || hasProductFeatures()) 
            ? 2 
            : 1} 
          style={{ marginBottom: '20px' }} 
      />
      <div className="mb-3">
        <Label htmlFor="createAudienceName" className="form-label">Name</Label>
        <Input type="text"
          className="form-control"
          id="createAudienceName"
          placeholder="Enter name"
          name='name' value={createAudienceName}
          onChange={(e) => setCreateAudienceName(e.target.value)} />
      </div>

      {hasFeature("manuel::os_type") && (
      <div className="mb-3">
        <Label for="osTypeSelect" className="form-label">OS Type</Label>
        <Input type="select" name="osType" id="osTypeSelect" className="form-control" value={osType} onChange={(e) => setOsType(e.target.value)}>
          <option>ANDROID</option>
          <option>IOS</option>
          <option>MIXED</option>
        </Input>
      </div>)}


      {hasFeature("manuel::profile") && (
  <>

      <div className="mb-3 d-flex align-items-center">
        <Label for="personaTypeSelect" className="form-label">Persona Type</Label>
        <div style={{ marginLeft: 'auto' }}>
          <Switch 
            onChange={handleConditionToggle} 
            checked={andOrCondition} 
            offColor="#234d6f"
            onColor="#cc2277"
            uncheckedIcon={
              <div style={{ padding: '5px', color: 'white', textAlign: 'center', fontSize: '11px' }}>OR</div>
            }
            checkedIcon={
              <div style={{ padding: '5px', color: 'white', textAlign: 'center', fontSize: '11px' }}>AND</div>
            }
            height={24} 
            handleDiameter={22}
          />
        </div>
        

      </div>
      <Select
          isMulti
          id="personaTypeSelect"
          options={filteredProfileTypeOptions}
          value={selectedPersonaType}
          onChange={setSelectedPersonaType}
          placeholder="Select Persona Type..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '103%',
              marginLeft: '-1.5%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(0.5em + 0.10rem )'
            }),
          }}
        />
        </>
        )}


{hasFeature("manuel::user_status") && (
  <FormGroup>
    <Label for="userStatusSelect">User Status</Label>
    <Input type="select" name="userStatus" id="userStatusSelect" className="form-control" value={userStatus} onChange={(e) => setUserStatus(e.target.value)}>
      <option>ACTIVE</option>
      <option>INACTIVE</option>
      <option>MIXED</option>
    </Input>
  </FormGroup>
)}

      {hasFeature("manuel::time_range") && (
  <Row form className="mb-3">
    <Label for="startDate">Time Range</Label>
    <Col md={6}>
      <FormGroup>
        <div className="input-group">
          <span className="input-group-text">Start</span>
          <Input type="date" id="startDate" value={startDate} onChange={(e) => setStartDate(e.target.value)} min={oneYearAgo} max={endDate} />
        </div>
      </FormGroup>
    </Col>
    <Col md={6}>
      <FormGroup>
        <div className="input-group">
          <span className="input-group-text">End</span>
          <Input type="date" id="endDate" value={endDate} onChange={(e) => setEndDate(e.target.value)} min={startDate} max={today} />
        </div>
      </FormGroup>
    </Col>
  </Row>
)}

      <div className="hstack gap-2 justify-content-end">
        {hasStep2Features() || hasProductFeatures() ? (
            <Button type="button" color="primary" onClick={() => setStep(hasStep2Features()? 2:3)}>Next</Button>
          ) : (
            <Button 
              type="submit" 
              color="success" 
              disabled={!createAudienceName.trim()}
            >
              Create Audience
            </Button>
          )}
      </div>
    </>
  );
  const hasProductFeatures = () => {
    return hasFeature("manuel::product_prediction") || hasFeature("manuel::product_analytic");
  };

  const renderStep2 = () => (
    <>
      <Progress 
          value={2} 
          max={(hasStep2Features() && hasProductFeatures()) 
            ? 3 
            : (hasStep2Features() || hasProductFeatures()) 
            ? 2 
            : 1} 
          style={{ marginBottom: '20px' }} 
      />
      {hasFeature("manuel::generation") && 
      (<div className="mb-3">
        <Label for="generationSelect" className="form-label">Generations</Label>
        <Select
          isMulti
          id="generationSelect"
          options={generationOptions}
          value={generations}
          onChange={setGenerations}
          placeholder="Select Generations..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '104%',
              marginLeft: '-2%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(1.5em + 0.75rem + 2px)'
            }),
          }}
        />
      </div>)}

      {hasFeature("manuel::gender") && 
      (<div className="mb-3">
        <Label for="genderSelect" className="form-label">Genders</Label>
        <Select
          isMulti
          id="genderSelect"
          options={genderOptions}
          value={genders}
          onChange={setGenders}
          placeholder="Select Genders..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '104%',
              marginLeft: '-2%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(1.5em + 0.75rem + 2px)'
            }),
          }}
        />
      </div>)}

      {hasFeature("manuel::app") && (
        <>
      <div className="mb-3">
        <Label for="inAppsInput" className="form-label">Include Apps</Label>
        <Select
          isMulti
          id="inAppsInput"
          options={appOptions}
          value={inApps}
          onChange={setInApps}
          placeholder="Select Include Apps..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '104%',
              marginLeft: '-2%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(1.5em + 0.75rem + 2px)'
            }),
          }}
        />
      </div>

      <div className="mb-3">
        <Label for="notInAppsInput" className="form-label">Exclude Apps</Label>
        <Select
          isMulti
          id="notInAppsInput"
          options={appOptions}
          value={notInApps}
          onChange={setNotInApps}
          placeholder="Select Exclude Apps..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '104%',
              marginLeft: '-2%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(1.5em + 0.75rem + 2px)'
            }),
          }}
        />
      </div>
      </>
      )}

{hasFeature("manuel::location") && (
      <div className="mb-3">
        <Label for="locationSelect" className="form-label">Select Location</Label>
        <Select
          isMulti
          id="locationSelect"
          options={locations.map(loc => ({ value: loc, label: `Lat: ${loc.lat}, Lon: ${loc.lon}, Radius: ${loc.meter}m` }))}
          value={locations.map(loc => ({ value: loc, label: `Lat: ${loc.lat}, Lon: ${loc.lon}, Radius: ${loc.meter}m` }))}
          onChange={(selected) => setLocations(selected.map(option => option.value))}
          onMenuOpen={() => setShowMap(true)}
          placeholder="Select Location..."
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (provided) => ({
              ...provided,
              width: '104%',
              marginLeft: '-2%',
              borderRadius: '0.25rem',
              borderColor: '#ced4da',
              minHeight: 'calc(1.5em + 0.75rem + 2px)'
            }),
          }}
        />
      </div>)}

      {showError && (
        <Alert color="danger">
          An app cannot be in both "Include Apps" and "Exclude Apps" lists.
        </Alert>
      )}

      <div className="hstack gap-2 justify-content-end">
      <Button type="button" color="secondary" onClick={() => setStep(1)}>Back</Button>
          {hasProductFeatures() ? (
            <Button type="button" color="primary" onClick={() => setStep(3)}>Next</Button>
          ) : (
            <Button type="submit" color="success" disabled={!createAudienceName.trim()}>
            {loading ? 'Creating...' : 'Create Audience'}
          </Button>
          )}
      </div>
    </>
  );

  const addNewProduct = () => {
    if (products[0].name) {
      // Add the current selection to the list
      setProducts([
        // Reset the current row
        { 
          name: '', 
          minUsage: 0, 
          productType: 'Purchase', 
          forAnalytics: true, 
          forPrediction: false 
        },
        // Add the current selection to the list
        ...products
      ]);
    }
  };
  const deleteProduct = (index) => {
    // Remove the product from the list but keep the current row
    const newProducts = [
      products[0], // Keep the current input row
      ...products.slice(1).filter((_, i) => i !== index - 1) // Filter out the deleted product from the history
    ];
    setProducts(newProducts);
  };
  const renderProductSummary = () => {
    // Only show products after the first row (which is the input row)
    const selectedProducts = products.slice(1);
    
    return (
      <Card className="mb-3">
        <CardBody>
          <h5 className="card-title mb-2">Selected Products</h5>
          {selectedProducts.length === 0 ? (
            <div className="text-muted">No products selected...</div>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {selectedProducts.map((product, index) => (
                <div 
                  key={index} 
                  className="border rounded p-2 d-flex align-items-center"
                  style={{ 
                    backgroundColor: '#f8f9fa',
                    minWidth: '200px'
                  }}
                >
                  <div className="flex-grow-1">
                    <div className="fw-bold">{product.name}</div>
                    <small className="text-muted">
                      Min Usage: {product.minUsage} | {product.productType}
                      <br />
                      {product.forAnalytics && 'Analytics'} 
                      {product.forAnalytics && product.forPrediction && ' & '} 
                      {product.forPrediction && 'Prediction'}
                    </small>
                  </div>
                  <Button 
                    color="link" 
                    className="p-0 ms-2" 
                    onClick={() => deleteProduct(index + 1)}
                  >
                    <X size={16} />
                  </Button>
                </div>
              ))}
            </div>
          )}
        </CardBody>
      </Card>
    );
  };

  const renderStep3 = () => {
    // If neither product feature is enabled, don't render step 3
    if (!hasProductFeatures()) {
      return null;
    }
  
    return (
      <>
        <Progress 
          value={3} 
          max={(hasStep2Features() && hasProductFeatures()) 
            ? 3 
            : (hasStep2Features() || hasProductFeatures()) 
            ? 2 
            : 1} 
          style={{ marginBottom: '20px' }} 
        />
        {renderProductSummary()}
        <Card className="mb-10">
          <CardBody>
            <h5 className="card-title mb-2">Product Configuration</h5>
            <Table responsive bordered hover className="mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '50%' }}>Product Name</th>
                  <th style={{ width: '15%', textAlign: 'center' }}>Min Usage</th>
                  <th style={{ width: '25%', textAlign: 'center' }}>Product Type</th>
                  {hasFeature("manuel::product_analytic") && (
                    <th style={{ width: '5%', textAlign: 'center' }}>For Analytics</th>
                  )}
                  {hasFeature("manuel::product_prediction") && (
                    <th style={{ width: '5%', textAlign: 'center' }}>For Prediction</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                      <Input
                        style={{paddingLeft: '1.5vh' }}
                        type="select"
                        value={products[0].name}
                        onChange={(e) => {
                          const newProducts = [...products];
                          newProducts[0].name = e.target.value;
                          setProducts(newProducts);
                        }}
                      >
                        <option value="">Select product...</option>
                        {productOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </td>
                    <td className="text-center">
                      <Input
                        style={{paddingLeft: '1.5vh' }}
                        type="select"
                        value={products[0].minUsage}
                        onChange={(e) => {
                          const newProducts = [...products];
                          newProducts[0].minUsage = parseInt(e.target.value);
                          setProducts(newProducts);
                        }}
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                      </Input>
                    </td>
                    <td className="text-center">
                      <Input 
                        style={{paddingLeft: '1.5vh' }}
                        type="select"
                        value={products[0].productType}
                        onChange={(e) => {
                          const newProducts = [...products];
                          newProducts[0].productType = e.target.value;
                          setProducts(newProducts);
                        }}
                      >
                        <option>Purchase</option>
                        <option>Interest</option>
                      </Input>
                    </td>
                    {hasFeature("manuel::product_analytic") && (
                      <td className="text-center">
                        <FormGroup check className="d-inline-block">
                          <Input
                            type="checkbox"
                            checked={products[0].forAnalytics}
                            onChange={(e) => {
                              const newProducts = [...products];
                              newProducts[0].forAnalytics = e.target.checked;
                              if (!e.target.checked && !newProducts[0].forPrediction && hasFeature("manuel::product_prediction")) {
                                newProducts[0].forPrediction = true;
                              }
                              setProducts(newProducts);
                            }}
                          />
                        </FormGroup>
                      </td>
                    )}
                    {hasFeature("manuel::product_prediction") && (
                      <td className="text-center">
                        <FormGroup check className="d-inline-block">
                          <Input
                            type="checkbox"
                            checked={products[0].forPrediction}
                            onChange={(e) => {
                              const newProducts = [...products];
                              newProducts[0].forPrediction = e.target.checked;
                              if (!e.target.checked && !newProducts[0].forAnalytics && hasFeature("manuel::product_analytic")) {
                                newProducts[0].forAnalytics = true;
                              }
                              setProducts(newProducts);
                            }}
                          />
                        </FormGroup>
                      </td>
                    )}
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-between align-items-center mb-10">
            <Button 
              color="primary" 
              onClick={addNewProduct} 
              className="d-flex align-items-center" 
              disabled={!products[0].name || products.length === 6}
            >
              <Plus size={16} className="me-2" />
              Add New Product
            </Button>
            <div>
              <Button type="button" color="secondary" onClick={() => setStep(hasStep2Features() ? 2:1)} className="me-2">
                Back
              </Button>
              <Button type="submit" color="success" disabled={!createAudienceName.trim()}>
            {loading ? 'Creating...' : 'Create Audience'}
            </Button>
            </div>
          </div>
      </>
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
      { hasStep2Features() ? (
          <>
            {step === 1 && renderStep1()}
            {step === 2 && renderStep2()}
            {hasProductFeatures() && step === 3 && renderStep3()}
          </>
        ) : (
          <>
             {step === 1 && renderStep1()}
             {step === 3 && renderStep3()}
          </>
        )
          
        }
      </form>

      {showMap && (
        <LocationPicker 
          locations={locations} 
          setLocations={setLocations} 
          toggleMap={() => setShowMap(false)} 
        />
      )}
    </>
  );
};

export default CreateTargetManuallyForm;
